import React, { PropTypes, Component } from 'react'
import { Field } from 'redux-form'

import './AddressForm.scss'
import InputControl from 'components/InputControl'

import { createFieldValidator, required } from 'utils/validations'

class AddressForm extends Component {
  constructor (props) {
    super(props)

    this.onChange = this.onChange.bind(this)

    this.state = {}
  }

  onChange (e) {
    if (!this.props.onChange) {
      return
    }

    const { name, value } = e.target

    const nameWithoutFormSection = name.split('.')[1]

    this.setState({
      [nameWithoutFormSection]: value
    }, this.notifyChange)
  }

  notifyChange () {
    const address = this.state
    this.props.onChange(address)
  }

  render () {
    return (
      <div className='AddressForm'>
        <div className='AddressForm-row'>
          <Field
            className='AddressForm-field'
            component={InputControl}
            name='street'
            type='text'
            label='Calle'
            onChange={this.onChange}
            validate={
              createFieldValidator([required])
            }
            />
        </div>

        <div className='AddressForm-row'>
          <Field
            className='AddressForm-field AddressForm-smallField'
            component={InputControl}
            name='number'
            type='text'
            label='Número exterior'
            onChange={this.onChange}
            validate={
              createFieldValidator([required])
            }
            />

          <Field
            className='AddressForm-field AddressForm-smallField'
            component={InputControl}
            name='interiorNumber'
            type='text'
            label='Número interior'
            />
        </div>

        <div className='AddressForm-row'>
          <Field
            className='AddressForm-field'
            component={InputControl}
            name='neighborhood'
            type='text'
            label='Colonia'
            onChange={this.onChange}
            validate={
              createFieldValidator([required])
            }
            />
        </div>

        <div className='AddressForm-row'>
          <Field
            className='AddressForm-field'
            component={InputControl}
            name='city'
            type='text'
            label='Delegación'
            onChange={this.onChange}
            validate={
              createFieldValidator([required])
            }
            />
        </div>

        <div className='AddressForm-row'>
          <Field
            className='AddressForm-field'
            component={InputControl}
            name='state'
            type='text'
            label='Estado'
            onChange={this.onChange}
            validate={
              createFieldValidator([required])
            }
            />
        </div>
      </div>
    )
  }
}

AddressForm.displayName = 'AddressForm'
AddressForm.propTypes = {
  onChange: PropTypes.func
}

export default AddressForm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/SecondTimeBookingConfirmation/components/AddressForm/AddressForm.js